import { IAuthStrategiesConfig } from 'interfaces';
import { userIsInternal } from '../../util/user-is-internal';

export const sanitiseAuthStrategiesConfig = (config) => {
	return {
		...{ isAuthRequired: config.isAuthRequired ?? false },
		...(userIsInternal() ? config.internal : config.external),
	};
};
